import config from 'config'

export const generateAutoLoginUrl = (subdomain, token) => {
  const domain = config.appDomain
  return `https://${subdomain}.${domain}/auth/callback?access_token=${token}`
}
